<template>
  <!-- 员工管理 -->
  <div class="page-container">
    <!--工具栏-->
    <div class="toolbar">
      <el-form :inline="true" :model="filterForm" :size="size">
        <el-form-item label="">
          <el-input v-model="filterForm.name" placeholder="员工姓名" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.phone" placeholder="员工手机号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.idCard" placeholder="员工身份证号" clearable></el-input>
        </el-form-item>
        <el-form-item label="">
          <el-input v-model="filterForm.positions" placeholder="员工职位" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-search"
            label="查询"
            perms="-1"
            type="primary"
            @click="handleSearch"
          />
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-share"
            label="重置"
            perms="-1"
            @click="handleReset"
            type="primary"/>
        </el-form-item>
        <el-form-item>
          <kt-button
            icon="fa fa-plus"
            label="新增"
            perms="31100"
            type="primary"
            @click="handleAdd"
          />
        </el-form-item>
      </el-form>
    </div>
    <!--表格树内容栏-->
    <el-table :data="staffList" stripe size="mini" style="width: 100%">
      <el-table-column
        type="index"
        width="50"
        align="center"
        fixed
        label="序号"
      ></el-table-column>
      <el-table-column
        prop="name"
        align="center"
        label="员工姓名"
      ></el-table-column>
      <el-table-column
        prop="phone"
        align="center"
        label="员工手机"
      ></el-table-column>
      <el-table-column
        prop="idCard"
        align="center"
        label="身份证号码"
      ></el-table-column>
      <el-table-column
        prop="positions"
        align="center"
        label="员工职位"
      ></el-table-column>
      <el-table-column
        prop="phone"
        align="center"
        label="手机号"
      ></el-table-column>
      <!-- <el-table-column
        prop="createTime"
        align="center"
        width="150"
        label="注册时间"
      >
        <template slot-scope="scope">{{ scope.createTime }}</template>
      </el-table-column>
      <el-table-column
        prop="updateTime"
        align="center"
        width="150"
        label="更新时间"
      >
        <template slot-scope="scope">{{ scope.updateTime }}</template>
      </el-table-column> -->
      <el-table-column
        fixed="right"
        align="left"
        width="350"
        show-overflow-tooltip
        label="操作"
      >
        <template slot-scope="scope">
          <kt-button
            icon="el-icon-connection"
            label="授权"
            perms="31103"
            @click="handleAuth(scope.row)"
          />
          <kt-button
            icon="fa fa-edit"
            label="修改"
            perms="31101"
            @click="handleEdit(scope.row)"
          />
          <kt-button
            icon="fa fa-trash"
            label="删除"
            perms="31102"
            type="danger"
            @click="handleDelete(scope.row)"
          />
        </template>
      </el-table-column>
    </el-table>
    <!--分页栏-->
    <div class="toolbar" style="padding: 20px">
      <el-pagination
        background
        layout="total, prev, pager, next"
        @current-change="refreshPageRequest"
        :current-page="pageNo"
        :page-size="pageSize"
        :total="totalSize"
        style="float: right"
      ></el-pagination>
    </div>
    <!-- 新增员工弹窗 -->
    <el-dialog
      width="500px"
      label-position="center"
      :title="staffDialogTitle"
      :visible.sync="staffDialogVisible"
      :lock-scroll="true"
      custom-class="dialogClass"
      :close-on-click-modal="false"
      :before-close="handleCloseRole"
    >
      <el-form
        :model="staffForm"
        :rules="staffRules"
        ref="staffForm"
        label-width="100px"
        :size="size"
        class="staffForm"
        @keyup.enter.native="submitStaffForm()"
      >
        <el-form-item label="员工姓名" prop="name">
          <el-input v-model="staffForm.name" placeholder="请输入员工姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="员工手机" prop="phone">
          <el-input v-model="staffForm.phone" placeholder="请输入手机号">
          </el-input>
        </el-form-item>
        <el-form-item label="身份证" prop="idCard">
          <el-input v-model="staffForm.idCard" placeholder="请输入身份证号">
          </el-input>
        </el-form-item>
        <el-form-item label="登录密码" prop="pass">
          <el-input v-model="staffForm.pass" placeholder="请输入密码">
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="员工工号" prop="cardNo">
          <el-input v-model="staffForm.cardNo" placeholder="请输入工号">
          </el-input>
        </el-form-item> -->
        <el-form-item label="员工职位" prop="positions">
          <el-input v-model="staffForm.positions" placeholder="请输入职位">
          </el-input>
        </el-form-item>
        <el-form-item label="是否需要短信验证码登录" label-width="200px" prop="loginVerifyStatus" v-if="hasPermission('31104')">
          <el-radio-group v-model="staffForm.loginVerifyStatus">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="handleCloseRole">取消</el-button>
        <el-button :size="size" type="primary" @click="submitStaffForm">保存</el-button>
      </span>
    </el-dialog>
    <!-- 授权弹窗 -->
    <el-dialog
      width="50%"
      label-position="center"
      title="授权"
      :visible.sync="authDialogVisible"
      :lock-scroll="true"
      custom-class="dialogClass"
      :close-on-click-modal="false"
      :before-close="handleCloseAuth"
    >
      <div class="authName">姓名：{{authName}}</div>
      <el-transfer
        filterable
        filter-placeholder="关键词搜索"
        v-model="selectRole"
        :titles="transferTitles"
        :data="roleList"
        :props="defaultProps"
      >
      </el-transfer>
      <span slot="footer" class="dialog-footer">
        <el-button :size="size" @click="handleCloseAuth">取消</el-button>
        <el-button :size="size" type="primary" @click="handleSaveAuth">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import KtButton from "@/components/Core/KtButton";
import { hasPermission } from '@/permission/index.js'
export default {
  components: {
    KtButton,
  },
  data() {
    return {
      size: "small",
      filterForm: {},
      pageNo: 1,
      pageSize: 10,
      totalSize: 0,
      staffList: [], //员工列表
      staffDialogTitle: '新增',
      staffDialogVisible: false, // 新增编辑员工弹窗
      staffForm: {},
      staffRules: {
        name: [ { required: true, message: "请输入员工姓名", trigger: "blur" }],
        phone: [ { required: true, message: "请输入员工手机号", trigger: "blur" }],
        idCard: [ { required: true, message: "请输入员工身份证", trigger: "blur" }],
        pass: [ { required: true, message: "请输入员工密码", trigger: "blur" }],
        positions: [ { required: true, message: "请输入员工职位", trigger: "blur" }],
        loginVerifyStatus: [ { required: true, message: "请选择", trigger: "blur" }],
      },
      authDialogVisible: false, // 授权弹窗
      transferTitles: ['全部角色', '已拥有'],
      defaultProps: {
        key: 'roleId',
        label: 'roleName'
      },
      roleList: [],
      selectRole: [],
      authName: '',
      authSaffId: ''
    };
  },
  mounted() {
    this.getStaffList();
    this.getRoleList();
  },
  methods: {
    // 获取用户列表
    async getStaffList() {
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }
      let index = 0
      for (let key in this.filterForm) {
        const val = this.filterForm[key]
        if (val && val !== '') {
          params['searchFieldList[' + index + '].fieldName'] = key
          params['searchFieldList[' + index + '].singleValue'] = val
          index++
        }
      }
      let res = await this.$api.system.mGetStaffList(params);
      this.staffList = res.data.dtoList;
      this.totalSize = res.data.totalSize;
    },
    // 获取角色列表
    async getRoleList() {
      let res = await this.$api.system.mGetRoleList({
        pageNo: this.pageNo,
        pageSize: 1000
      })
      this.roleList = res.data.dtoList;
    },

    // 换页刷新
    refreshPageRequest(pageNo) {
      this.pageNo = pageNo;
      this.getStaffList();
    },
    // 搜索
    handleSearch() {
      this.pageNo = 1;
      this.getStaffList();
    },
    // 重置搜索条件
    handleReset() {
      this.filterForm = {

      }
      this.getStaffList()
    },
    // 显示新增界面
    handleAdd() {
      this.staffDialogTitle = '新增'
      this.staffDialogVisible = true;
    },

    // 显示编辑界面
    handleEdit(row) {
      this.staffDialogTitle = '编辑'
      this.staffForm = JSON.parse(JSON.stringify(row))
      this.staffDialogVisible = true;
    },

    // 关闭弹窗
    handleCloseRole() {
      this.staffDialogVisible = false
      this.$refs['staffForm'].resetFields()
      this.staffForm = {}
    },

    // 新增编辑提交
    submitStaffForm() {
      this.$refs['staffForm'].validate(async (valid) => {
        if (valid) {
          let addEditStaffApi = this.staffForm.staffId
          ? 
          this.$api.system.mEditStaff
          : 
          this.$api.system.mSaveStaff
          let res = await addEditStaffApi(this.staffForm)
          this.staffDialogVisible = false
          this.$refs['staffForm'].resetFields()
          this.$message({ message: "保存成功", type: "success" });
          this.getStaffList()
        }
      })
    },

    // 删除员工
    handleDelete(row) {
      this.$confirm("确认删除该员工吗？", "提示", {
        type: "warning",
      }).then(async () => {
        let res = await this.$api.system.mDeleteStaff({
          staffId: row.staffId,
        })

        if(+res.code === 0){
          this.getStaffList();
          this.$message({ message: "删除成功", type: "success" });
        }
      });
    },

    // 员工授权
    async handleAuth(row){
      let res = await this.$api.system.mGetStaffRoles({
        staffId: row.staffId
      })
      // console.log(res)

      this.selectRole = !res.data ? [] : res.data 
      this.authName = row.name
      this.authSaffId = row.staffId;
      this.authDialogVisible = true
    },

    // 关闭授权弹窗
    handleCloseAuth(){
      this.authName = '';
      this.authSaffId = '';
      this.selectRole = [];
      this.authDialogVisible = false
    },

    // 保存授权
    async handleSaveAuth(row){
      // console.log(row)
      let res = await this.$api.system.mSetGrantPermission({
        roleIdList: this.selectRole,
        staffId: this.authSaffId
      })

      this.handleCloseAuth()
      this.$message({ message: "授权成功", type: "success" });
    },
    hasPermission
  },
};
</script>

<style lang="scss" scoped>
.page-container{
  box-sizing: border-box;
  padding: 10px;
}
.toolbar {
  width: 100%;
  padding: 10px 10px 30px;
  box-sizing: border-box;
}
.authName{
  margin-top: -20px;
  padding-bottom: 10px;
  font-size: 16px;
  color: #000;
}
</style>